import React from 'react';

interface ModalFooterProps {
  onUseThemeColors: () => void;
  onCancel: () => void;
  onSave: () => void;
  isLoading: boolean;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  onUseThemeColors,
  onCancel,
  onSave,
  isLoading,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 p-6 border-t border-gray-200">
    <button
      onClick={onUseThemeColors}
      className="px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors flex items-center space-x-2"
      disabled={isLoading}
      title="Clear custom colors and use defaults"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
        />
      </svg>
      <span>Use Default Colors</span>
    </button>

    <div className="flex items-center space-x-3">
      <button
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        disabled={isLoading}
      >
        Cancel
      </button>
      <button
        onClick={onSave}
        disabled={isLoading}
        className="px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  </div>
);

interface ThemeColorsConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const ThemeColorsConfirmModal: React.FC<ThemeColorsConfirmModalProps> = ({
  onConfirm,
  onCancel,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
    <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Use Default Colors?</h3>
      <p className="text-sm text-gray-600 mb-6">
        This will clear all custom colors for this component and revert to the defaults. This action
        cannot be undone.
      </p>
      <div className="flex justify-end space-x-3">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md"
        >
          Use Default Colors
        </button>
      </div>
    </div>
  </div>
);
